import { HTMLAttributes } from "react"
import { Property } from "csstype"
import { styled, CSS, CSSFn, callCSSFn, StyleProps } from "../styles"

export const boxCss = { boxSizing: `border-box` } as CSS
interface Props {
  css?: CSSFn
  width?: Property.Width
  as?: `div` | `span` | `ul`
}

type Component = HTMLSpanElement | HTMLDivElement | HTMLUListElement

type StyledBoxProps = Props & StyleProps

const makeCss = (props: StyledBoxProps) => ({
  ...boxCss,
  width: props.width,
  ...callCSSFn(props),
})

const StyledBoxUL = styled.ul<StyledBoxProps>((props: StyleProps) => makeCss(props))
const StyledBoxSpan = styled.span<StyledBoxProps>((props: StyleProps) => makeCss(props))
const StyledDivSpan = styled.div<StyledBoxProps>((props: StyleProps) => makeCss(props))

export const Box = ({ as, ...props }: Props & HTMLAttributes<Component>) => {
  if (as === `span`) return <StyledBoxSpan {...props} />
  if (as === `ul`) return <StyledBoxUL {...props} />
  return <StyledDivSpan {...props} />
}

Box.defaultProps = {
  css: undefined,
  as: `div`,
  width: undefined,
}
